import AppContext from "Context/appContext";
// import { fetchSettingsForSubId } from "api";
import UrlServices from "../../services/Url";
import Card from "components/Card";
import Input from "components/Input";
import "containers/ProductList/index.css";
import { PAGES } from "constants";
import { memo, useContext, useEffect, useState } from "react";

let load = true;

const ProductList = () => {
  const {
    productCartDetail,
    setProductCartDetail,
    productCartData,
    setProgressState,
    products,
    setProducts,
    setAllProducts,
    loading,
    setLoading,
    prevState,
    setPrevState,
    progressState,
    currentModelsServices,
    setCurrentModelsServices,
    setIsMissedItem,
    allServices,
    setAllServices,
    setUserSettings,
    allServicesForSubId,
    setAllServicesForSubId,
    widthProductSection,
    setWidthProductSection,
    encryptionKey,
    isWebView,
    userSettings,
    setSelectedStoreDetails,
    setSelectedBookingPage,
    setToggle,
    setDefaultStore,
    setBookingList,
    setFilteredBookingList,
  } = useContext(AppContext);

  const [search, setSearch] = useState("");
  const [searchProducts, setSearchProducts] = useState([]);

  const base_url = process.env.REACT_APP_APPOINTMENT_PRO_API_URL;

  useEffect(() => {
    // Function to update width of product section
    const updateWidthProductSection = () => {
      const productSection = document.getElementById("product-section");
      if (productSection) {
        setWidthProductSection(productSection.offsetWidth);
      }
    };

    // Initial call to set div width
    updateWidthProductSection();

    // Event listener for window resize
    window.addEventListener("resize", updateWidthProductSection);

    const fetchData = async () => {
      if (products.length > 0 || !load) return;
      setLoading(true);
      try {
        load = false;
        const res = await fetch(`${base_url}/${UrlServices.fetchAllCategories}`, {
          method: "POST",
          headers: {
            "Content-Type": "application/json",
          },
          body: JSON.stringify({ q_: encryptionKey }),
        });
        const data = await res.json();
        let newCategories = data.user_data.map((category) =>
          category.brands.filter((brand) => brand.isFavorite)
        );
        const filteredData = [...data.user_data, ...newCategories];
        setProducts(filteredData.flat());
        setAllProducts(filteredData.flat());
        setSearchProducts(filteredData.flat());
        setAllServicesForSubId(data.default_data);
        setUserSettings(data.settings);

        // condition added if there is only one store, SKIP selection of store (step)
        if (data.get_all_stores.length === 1) {
          setSelectedBookingPage(data.get_all_stores[0]);
          setToggle(true);
          setDefaultStore(true);
          setSelectedStoreDetails({
            store_id: data.get_all_stores[0].store_id,
            store_name: data.get_all_stores[0].name,
          });
          // Set bookingList for progress calculation
          setBookingList(data.get_all_stores);
          setFilteredBookingList(data.get_all_stores);
          return;
        }

        setBookingList(data.get_all_stores);
        setFilteredBookingList(data.get_all_stores); // Initialize filtered list with all data
      } catch (error) {
        console.log(error);
      } finally {
        updateWidthProductSection();
        setLoading(false);
      }
    };
    fetchData();
    return () =>
      window.removeEventListener("resize", updateWidthProductSection);
  }, [widthProductSection, progressState]);

  const filteredProducts = (currentIndex, productName, productId) => {
    if (productName === "Others" && productId === "others") {
      const s = allServicesForSubId.map((c) => ({
        ...c,
        active: false,
      }));
      setProducts(s);
      setProgressState(3);
      setCurrentModelsServices([]);
      setProductCartDetail({
        ...productCartDetail,
        model: {},
        services: [],
        skipForOthers: true,
      });
    }

    let selectedItem = search
      ? searchProducts[currentIndex]
      : products[currentIndex];
    if (progressState !== 3) {
      setPrevState({ ...prevState, [progressState]: products });
    }

    setProgressState((prevState) => {
      if (prevState === 3) return prevState;
      if (prevState === 0 && selectedItem.isFavorite) {
        const category = products?.find(
          (product) => product._id === selectedItem.category
        );
        setProductCartDetail({
          ...productCartDetail,
          category,
          brand: selectedItem,
        });
        setIsMissedItem({ ...selectedItem });
        return prevState + 2;
      } else {
        return prevState + 1;
      }
    });
    if (selectedItem?.brands) {
      // If brands exist, return the brands array
      setProductCartDetail({ ...productCartDetail, category: selectedItem });
      setProducts(selectedItem.brands);
    } else if (selectedItem?.models) {
      setProductCartDetail({ ...productCartDetail, brand: selectedItem });
      // If models exist, return the models array
      setCurrentModelsServices(selectedItem.services);
      setAllServices(selectedItem.services);
      setProducts(selectedItem.models);
    } else if (currentModelsServices?.length > 0) {
      // If services exist, return the services array
      setProductCartDetail({ ...productCartDetail, model: selectedItem });
      const filteredServices = allServices
        .filter((service) => service.model._id === selectedItem._id)
        .map((c) => ({ ...c, active: false }));
      setProducts(filteredServices);
      setCurrentModelsServices([]);
    } else {
      const services = productCartDetail?.services
        ? productCartDetail?.services
        : [];

      const key = selectedItem?.hasOwnProperty("_id") ? "_id" : "id";
      const newItem =
        services?.findIndex((s) => s[key] === selectedItem[key]) >= 0;

        if (selectedItem?.sale_price) {
          let price;
          
          // 1. Check online_price first
          if (userSettings.showOnline && selectedItem.online_price && 
              typeof selectedItem.online_price === "string" && 
              !selectedItem.online_price.startsWith("0")) {
            price = selectedItem.online_price;
            selectedItem["price"] = parseFloat(price);
          } 
          // 2. If online_price is invalid, check sale_price
          else if (selectedItem.sale_price && 
                   typeof selectedItem.sale_price === "string" && 
                   !selectedItem.sale_price.startsWith("0")) {
            price = selectedItem.sale_price;
            selectedItem["price"] = parseFloat(price);
          } 
          // 3. Fallback to retail_price
          else {
            price = selectedItem.retail_price;
            if (selectedItem?.retail_price && !selectedItem.retail_price.startsWith("0")) {
              selectedItem["price"] = parseFloat(price);
            } else {
              selectedItem["price"] = 0.00;
            }
          }
        }

      let totalPrice =
        productCartDetail?.totalPrice === undefined ||
        productCartDetail?.totalPrice === 0
          ? selectedItem?.price
          : selectedItem?.price + productCartDetail?.totalPrice;

      selectedItem["active"] = !selectedItem?.active;

      if (newItem) {
        //if the item is already existed
        let totalPrice = productCartDetail?.totalPrice - selectedItem.price;
        if (isNaN(totalPrice) || totalPrice === undefined) {
          totalPrice = 0;
        }
        const updatedList = productCartDetail.services.filter(
          (p) => p[key] !== selectedItem[key]
        );
        setProductCartDetail({
          ...productCartDetail,
          totalPrice,
          services: updatedList,
        });
        setProducts([...products]);
        return;
      }
      // data will get from our database
      if (!productCartData && !productCartDetail?.model) {
        if (selectedItem?.model) {
          setProductCartDetail({
            ...productCartDetail,
            totalPrice,
            services: [...services, selectedItem],
          });
        }
      } else {
        // data will get from our repairdesk database
        setProductCartDetail({
          ...productCartDetail,
          totalPrice,
          services: [...services, selectedItem],
        });
      }
    }
  };

  const getFilteredProducts = () => {
    if (!search) return products;
    return products?.filter((p) =>
      p.name.toLowerCase().includes(search.toLowerCase())
    );
  };

  const handleChange = (e) => {
    setSearch(e.target.value);
    setSearchProducts(
      products?.filter((p) =>
        p.name.toLowerCase().includes(e.target.value.toLowerCase())
      )
    );
  };

  const displayedProducts =
  progressState === 3
    ? [...getFilteredProducts()]
    : [
        ...getFilteredProducts(),
        ...(userSettings.showOther ? [{ name: "Others", _id: "others" }] : [])
      ];

  return (
    <>
      {products?.length > 0 && !loading && (
        <div
          className={`quote-product-main ${
            productCartDetail?.model ? "quote-card-width" : "rd-quote-w-[100%]"
          } ${
            isWebView &&
            progressState === 3 &&
            !productCartDetail?.skipForOthers
              ? "rd-quote-mr-5"
              : ""
          } `}
        >
          <Input
            placeholder={`Search ${
              PAGES[progressState] === "Select Issues"
                ? "issues"
                : PAGES[progressState]
            }`}
            isShowIcon={true}
            value={search}
            handleChange={handleChange}
            className="input-field-search"
          />

          {displayedProducts?.length > 0 ? (
            <div
              id="product-section"
              className={`quote-product-section quote-scroller-hide quote-bottom-padding rd-quote-justify-between rd-quote-gap-x-[2%] xs:rd-quote-gap-x-[2%] lg:rd-quote-gap-x-[2%] rd-quote-gap-y-6 ${
                productCartDetail?.model
                  ? ""
                  : "lg:rd-quote-gap-x-0 base-max-height"
              }
                ${
                  progressState === 3 ? "max-height-mob-3" : "issues-max-height"
                }
                ${
                  progressState === 0 ||
                  progressState === 1 ||
                  progressState === 2 ||
                  progressState === 3
                    ? "xs:rd-quote-justify-between lg:rd-quote-justify-start"
                    : ""
                }
                `}
            >
              {displayedProducts?.map((p, index) => (
                <Card
                  key={p._id || index}
                  index={index}
                  product={p}
                  filteredProducts={filteredProducts}
                  setProducts={setProducts}
                  setSearch={setSearch}
                />
              ))}
            </div>
          ) : (
            <div className="rd-quote-w-full rd-quote-flex rd-quote-justify-center rd-quote-items-center xs:rd-quote-pt-5 md:rd-quote-pt-0 lg:rd-quote-h-[55vh]">
              <div className="rd-quote-my-auto rd-quote-text-gray-600 rd-quote-text-base rd-quote-font-semibold">
                No Results Found
              </div>
            </div>
          )}
        </div>
      )}
    </>
  );
};

export default memo(ProductList);
